<template>
  <div class="shipping-area">
    <div class="row justify-start q-gutter-sm">
      <div class="col-12">
        <info :message="$ts('info.shippingMethod')"></info>
      </div>
      <div v-if="readOnly" class="col-12">
        <q-chip class="q-ml-lg" color="green-2">{{ getDeliveryMethodString }}</q-chip>
      </div>
      <div v-else class="col-12 bg-grey-2 rounded-borders">
        <q-field class="required" :error="$v.sale_delivery_method.$error" hide-bottom-space borderless>
          <template slot="control">
            <div class="row q-col-gutter-sm items-center">
              <div v-if="filterShippingMethods.length > 0" class="col-auto">
                <q-option-group
                  v-model="sale_delivery_method"
                  inline
                  type="radio"
                  :options="filterShippingMethods"
                  :disable="$wait.is(['isAddressLoading'])"
                />
              </div>
              <div class="col-auto">
                <q-btn color="primary" flat icon="info">
                  <q-tooltip :offset="[5, 5]">
                    <div v-for="info in shippingMethodInfoOptions" class="info">
                      {{ info.label }}
                    </div>
                  </q-tooltip>
                </q-btn>
              </div>
            </div>
          </template>
        </q-field>
      </div>
      <div class="col-12">
        <shipping-method-delivery
          v-if="shippingDeliveryID === sale_delivery_method || showDeliveryAddressAlways"
          ref="shippingMethodDelivery"
          v-model="localAddressData"
          :member-addresses="memberAddresses"
          :country-id="countryId"
          :enable-cross-country="enableCrossCountry"
          :read-only="readOnly"
          :auto-fill-data="autoFillData"
          :show-ic-passport-field="showDeliveryAddressAlways"
          :delivery-method="getDeliveryMethod"
          mixin-process-mounted
        />
        <shipping-method-self-collection
          v-if="shippingSelfPickupID === sale_delivery_method"
          ref="shippingMethodSelfCollection"
          v-model="localAddressData"
          :country-id="countryId"
          :transaction-location-id="transactionLocationId"
          :read-only="readOnly"
          :delivery-method="getDeliveryMethod"
          :disable-collection-point-selection="disableCollectionPointSelection"
          :auto-fill-data="autoFillData"
          mixin-process-mounted
        />
      </div>
      <div class="col-12">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import ShippingMethodDelivery from './ShippingMethodDelivery'
import ShippingMethodSelfCollection from './ShippingMethodSelfCollection'
import shippingMethodsCommonMixin from 'src/application/global/mixins/shippingMethodsCommonMixin'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ShippingMethods',
  components: {
    ShippingMethodSelfCollection,
    ShippingMethodDelivery,
  },
  mixins: [shippingMethodsCommonMixin],
  props: {
    forceIncludeShippingMethods: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    sale_delivery_method: {
      required,
    },
  },
  data() {
    return {
      sale_delivery_method: null,
    }
  },
  watch: {
    filterShippingMethods: {
      async handler(to) {
        if (!this.readOnly) {
          let exist = to.find(x => x.value === this.sale_delivery_method)
          if (!exist) {
            this.sale_delivery_method = this.$helpers.getValue(to, '[0].value', null)
          }
        } else {
          this.sale_delivery_method = this.$helpers.getValue(this.autoFillData, 'sale_delivery_method', null)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    filterShippingMethods() {
      let filter = this.availableShippingOptions.filter(x => this.deliveryMethodEnabler(x.value))
      filter = [...this.forceIncludeShippingMethods, ...filter]
      return _.uniqBy(filter, 'label')
    },
    getDeliveryMethod() {
      return this.sale_delivery_method
    },
  },
  methods: {
    deliveryMethodEnabler(value) {
      if (this.shippingDeliveryID === value) {
        if (this.removeSelfPickup) {
          return false
        }
      } else if (this.shippingSelfPickupID === value) {
        if (this.removeDelivery) {
          return false
        }
      } else if (this.shippingWithoutShippingID === value) {
        if (this.removeWithoutShipping) {
          return false
        }
      }
      return true
    },
    async validate() {
      // Validating parent and child component
      this.$v.$touch()
      let validationPromise = []
      if (this.$refs.shippingMethodDelivery) {
        validationPromise.push(this.$refs.shippingMethodDelivery.validate())
      }
      if (this.$refs.shippingMethodSelfCollection) {
        validationPromise.push(this.$refs.shippingMethodSelfCollection.validate())
      }
      return await Promise.all(validationPromise).then(validation => {
        return validation.indexOf(true) !== -1 || this.$v.$error
      })
    },
  },
}
</script>
